export const RPProjectViewDisableExpandAllCount = 25;

export const RPEmployeeViewDisableExpandAllCount = RPProjectViewDisableExpandAllCount;
